import base64 from '../global/base64.js';
import md5 from 'js-md5'
import store from '@/store/index.js';
import timeHelper from '../global/timeHelper.js';
import axios from 'axios';
import global from '../global/global.js';
import {
  Message,
  Loading
} from 'element-ui'; //项目已经全局引入element的话可以不单独引入
let loading

const startLoading = () => { //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0)'
  })
}
const endLoading = () => { //使用Element loading-close 方法
  loading.close()
}

const fSmApiReq = async (sReqUrl, sApiName, sMethodName, sReqJsonStr, sApiUserPhone, sApiUserId, sApiReqFrom,
  sApiRandomStr, sApiReqOrgAk, sApiReqOrgSk, checkSignType = 'MD5') => {

  let sReqTime = timeHelper.fGetNowTime(2);
  // 请求参数BASE64
  let sReqJsonBase64 = Base64.encode(sReqJsonStr);
  // 组装签名

  let sApiReqSign = sApiReqOrgSk + sReqJsonBase64 + sReqTime + sApiReqOrgSk;
  sApiReqSign = md5(sApiReqSign);
  sApiReqSign = sApiReqSign.toLowerCase();
  let js = {};
  // API名称
  js['API_NAME'] = sApiName;
  // 请求方法名
  js['METHOD_NAME'] = sMethodName;
  // 请求json BASE64字符串
  js['REQ_JSON_STR'] = sReqJsonBase64;
  // API用户手机号
  js['API_USER_PHONE'] = sApiUserPhone;
  // API用户ID
  js['API_USER_ID'] = sApiUserId || '1001';
  // 请求来源
  js['API_REQ_FROM'] = sApiReqFrom;
  //版本号
  js['API_REQ_VER'] = '';
  // 请求TOKEN
  js['API_REQ_TOKEN'] = global.fGetPlatform().partnerInfo.token; //
  // 请求随机字符串
  js['API_RANDOM_STR'] = sApiRandomStr;
  // 请求机构AK
  js['API_REQ_ORG_AK'] = sApiReqOrgAk;
  // 请求签名
  js['API_REQ_SIGN'] = sApiReqSign;
  // 请求时间
  js['API_REQ_TIME'] = sReqTime;
  js['API_REQ_VER'] = 'smSellAdmin';

  js['RANDOM_STR'] = sApiRandomStr;
  js['REQ_JSON'] = sReqJsonBase64;
  js['MCH_ID'] = sApiUserPhone;
  js['USER_ID'] = sApiUserId || '1001';
  js['REQ_IP'] = '127.0.0.1';
  js['REQ_FROM'] = sApiReqFrom;
  js['REQ_VER'] = 'smSellAdmin';
  js['REQ_TIME'] = sReqTime;
  js['REQ_TOKEN'] = global.fGetPlatform().partnerInfo.token; //
  // startLoading()
  let res = await axios.post(sReqUrl, js);
  console.log(sReqUrl)
  if (res.data.result != 'sucess' && res.data.msg == 'tokenFail') {
    window.location.replace('http://www.sanmipos.com/smsoft/partnerAdmin/#/login')
    return {
      data: {
        result: 'fail',
        msg: '请重新登录'
      }
    }
  }
  // console.log(res, '总请求')
  if (!isObject(res.data)) {
    return {
      'result': 'fail',
      'msg': res
    };
  }
  return res.data;
};

function isObject(obj) {
  return typeof obj === 'object' && obj !== null;
}

const fPostToSmUnionQuery = (obj) => {
	let sReqUrl;
	sReqUrl = 'http://8.142.76.240/smUnionQuery/queryApi'; //tkAdmin  tkQry
	// sReqUrl = 'https://sanmipos.com/smUnionQuery/queryApi'; //tkAdmin  tkQry
  return fSmApiReq(sReqUrl, '', obj.sMethodName, JSON.stringify(obj.reqJson),
    global.fGetPlatform().partnerInfo.phone, '1001', 'WEB');
	// return fSmApiReq({
	// 	sReqUrl,
	// 	sMethodName: obj.sMethodName,
	// 	sReqJsonStr: JSON.stringify(obj.reqJson),
	// 	sApiUserPhone: global.fGetPlatform().partnerInfo.phone,
	// 	sApiUserId: '1001',
	// 	sApiReqFrom: 'WEB',
	// 	sApiRandomStr: obj.sApiRandomStr,
	// });
};
//smSell主服务器接口
const fPostToSmSellMainAdminApi = ({
  sMethodName,
  reqJson = {},
  url
}) => {
  let sReqUrl = 'https://www.91byk.com/smSellMains/smSellMainAdmin/adminApi';
  return fSmApiReq(sReqUrl, 'smSellAdminApi', sMethodName, JSON.stringify(reqJson),
    global.fGetPlatform().partnerInfo.phone, '1001', 'WEB');
};

//smSell主服务器接口
const fPostToSmSellMainQueryApi = (obj) => {
  let sReqUrl = 'https://www.91byk.com/smSellMains/smSellMainQuery/queryApi';
  return fSmApiReq(sReqUrl, 'smSellAdminApi', obj.sMethodName, JSON.stringify(obj.reqJson),
    global.fGetPlatform().partnerInfo.phone, '1001', 'WEB');
};


export default {
  fPostToSmSellMainAdminApi,
  fPostToSmSellMainQueryApi,
  fPostToSmUnionQuery
}



// WEBPACK FOOTER //
// ./src/common/requset/newSmApi.js